










const Privacypolicy = () => {

    return (
        <>
            <h1>Privacy Policy</h1>

            <p>This privacy policy applies to the Court Date Reminder app (hereby referred to as "Application") for mobile devices that was created by Gaurabh Kumar Jha (hereby referred to as "Service Provider") as a Free service. This service is intended for use "AS IS".</p>

            <h2>Information Collection and Use</h2>
            <p>The Application collects information when you download and use it. This information may include:</p>
            <ul>
                <li>Your device's Internet Protocol address (e.g. IP address)</li>
                <li>The pages of the Application that you visit, the time and date of your visit, the time spent on those pages</li>
                <li>The time spent on the Application</li>
                <li>The operating system you use on your mobile device</li>
            </ul>
            <p>The Application does not gather precise information about the location of your mobile device.</p>
            <p>The Service Provider may use the information you provide to contact you from time to time to provide important information, required notices, and marketing promotions.</p>
            <p>For a better experience, while using the Application, the Service Provider may require you to provide certain personally identifiable information, including but not limited to Mobile number and Email. This information will be retained and used as described in this privacy policy.</p>

            <h2>Third Party Access</h2>
            <p>Only aggregated, anonymized data is periodically transmitted to external services to aid the Service Provider in improving the Application and their service. The Service Provider may share your information with third parties as described in this privacy statement.</p>
            <p>The Service Provider may disclose User Provided and Automatically Collected Information:</p>
            <ul>
                <li>As required by law, such as to comply with a subpoena or similar legal process</li>
                <li>When they believe in good faith that disclosure is necessary to protect their rights, your safety or the safety of others, investigate fraud, or respond to a government request</li>
                <li>With their trusted service providers who work on their behalf, do not have an independent use of the information disclosed, and have agreed to adhere to this privacy statement</li>
            </ul>

            <h2>Opt-Out Rights</h2>
            <p>You can stop all collection of information by the Application easily by uninstalling it. You may use the standard uninstall processes available on your device or through the mobile application marketplace.</p>

            <h2>Data Retention Policy</h2>
            <p>The Service Provider will retain User Provided data for as long as you use the Application and for a reasonable time thereafter. If you'd like them to delete User Provided Data, please contact them at <a href="mailto:gouravkumarjhaa@gmail.com">gouravkumarjhaa@gmail.com</a> and they will respond within a reasonable time.</p>

            <h2>Children</h2>
            <p>The Service Provider does not knowingly solicit data from or market to children under the age of 13.</p>
            <p>The Service Provider encourages parents and legal guardians to monitor their children’s Internet usage and help enforce this policy by instructing their children never to provide personally identifiable information without permission.</p>
            <p>If you believe a child has provided personal information, please contact the Service Provider at <a href="mailto:gouravkumarjhaa@gmail.com">gouravkumarjhaa@gmail.com</a> so appropriate actions can be taken.</p>
            <p>You must also be at least 16 years of age to consent to the processing of your personally identifiable information in your country (or have your parent or guardian do so on your behalf).</p>

            <h2>Security</h2>
            <p>The Service Provider takes reasonable steps to safeguard the confidentiality of your information, using physical, electronic, and procedural measures to protect the data processed and maintained.</p>

            <h2>Changes</h2>
            <p>This Privacy Policy may be updated from time to time. The Service Provider will notify you of any changes by updating this page. Please review this Privacy Policy periodically for updates.</p>
            <p><strong>This privacy policy is effective as of 2025-06-13</strong></p>

            <h2>Your Consent</h2>
            <p>By using the Application, you consent to the processing of your information as outlined in this Privacy Policy, now and as amended by the Service Provider.</p>

            <h2>Contact Us</h2>
            <p>If you have any questions about privacy while using the Application, or about the practices in general, please contact the Service Provider at: <a href="mailto:gouravkumarjhaa@gmail.com">gouravkumarjhaa@gmail.com</a></p>
        </>
    )
}

export default Privacypolicy;